export const CCP_ABOVE_FIRST_ROW = 'above_first_row';
export const CCP_UNDER_FIRST_ROW = 'under_first_row';
export const CCP_UNDER_SECOND_ROW = 'under_second_row';
export const CCP_UNDER_THIRD_ROW = 'under_third_row';
export const CCP_UNDER_PRODUCT_LIST = 'under_product_list';
